import React, { ChangeEvent } from "react";

import { PopupItem } from "../../shared/siteContent";
import { SectionCard } from "../ui";

type PopupSectionProps = {
  popups: PopupItem[];
  files: Record<string, File | null>;
  canUpload: boolean;
  uploadGuardReason: string;
  onUpdate: (index: number, key: "enabled" | "link_url", value: unknown) => void;
  onFileSelect: (popupId: string, file: File | null) => void;
  onSave: () => void;
  onOpenPreview: (popupId: string) => void;
  saving: boolean;
};

/**
 * Popup 편집 섹션.
 * 슬롯별 활성화/링크/이미지 업로드와 미리보기를 제공한다.
 */
export function PopupSection({ popups, files, canUpload, uploadGuardReason, onUpdate, onFileSelect, onSave, onOpenPreview, saving }: PopupSectionProps) {
  return (
    <div className="cm-panel-grid">
      <div className="cm-actions">
        <button className="cm-btn" disabled={saving} onClick={onSave} type="button">
          {saving ? "저장 중..." : "Popup 저장"}
        </button>
      </div>
      {!canUpload ? <div className="cm-info">{uploadGuardReason}</div> : null}
      <div className="cm-grid-2">
        {popups.map((popup, index) => (
          <SectionCard
            className="cm-card-equal"
            key={popup.id}
            title={popup.id}
            actions={
              <>
                <span className={`cm-pill ${popup.enabled ? "ok" : "warn"}`.trim()}>{popup.enabled ? "활성" : "비활성"}</span>
                <button className="cm-btn cm-btn-preview" onClick={() => onOpenPreview(popup.id)} type="button">
                  미리보기
                </button>
              </>
            }
          >
            <div className="cm-panel-grid">
              <div className="cm-field">
                <label>미리보기</label>
                {popup.image_url ? (
                  <div className="cm-fixed-preview-box">
                    <img alt={popup.id} className="cm-fixed-preview-image" src={popup.image_url} />
                  </div>
                ) : (
                  <div className="cm-muted">이미지 없음</div>
                )}
              </div>

              <label className="cm-inline-row">
                <input checked={popup.enabled} onChange={(event) => onUpdate(index, "enabled", event.target.checked)} type="checkbox" />
                <span>enabled</span>
              </label>

              <div className="cm-field">
                <label htmlFor={`cm-popup-file-${popup.id}`}>이미지 파일</label>
                <input
                  accept="image/*"
                  className="cm-input"
                  disabled={!canUpload}
                  id={`cm-popup-file-${popup.id}`}
                  onChange={(event: ChangeEvent<HTMLInputElement>) => onFileSelect(popup.id, event.target.files?.[0] || null)}
                  type="file"
                />
                <div className="cm-muted">선택 파일: {files[popup.id]?.name || "(없음)"}</div>
                <div className="cm-muted">현재 파일: {popup.image_file || "(없음)"}</div>
              </div>

              <div className="cm-field">
                <label htmlFor={`cm-popup-link-${popup.id}`}>링크</label>
                <input
                  className="cm-input"
                  id={`cm-popup-link-${popup.id}`}
                  onChange={(event) => onUpdate(index, "link_url", event.target.value)}
                  placeholder="https://..."
                  value={popup.link_url || ""}
                />
                <div className="cm-path">storage_path: {popup.image_storage_path || "(없음)"}</div>
                <div className="cm-path">image_url: {popup.image_url || "(없음)"}</div>
              </div>

            </div>
          </SectionCard>
        ))}
      </div>
    </div>
  );
}
